import React from 'react';
import PropTypes from 'prop-types';

const Edit = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18">
    <path
      d="M10.221-12.472.451-2.7,0,1.313a.844.844,0,0,0,.931.932L4.949,1.8l9.773-9.773Zm7.284-.67-2.113-2.113a1.688,1.688,0,0,0-2.387,0l-1.988,1.988,4.5,4.5,1.988-1.988A1.688,1.688,0,0,0,17.506-13.142Z"
      transform="translate(0 15.75)"
      fill={color}
    />
  </svg>
);

Edit.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Edit.defaultProps = {
  width: 16,
  height: 16,
  color: '#000',
};

export default Edit;
